export default __webpack_public_path__ + "static/media/2_2022_07_22_БШУСайдын_А259_Багшийн_эрүүл_мэндийн_үзлэг_оношилгооны.acf29381.pdf";